import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { resolveNotifRoute } from "../../utils/notifRouteResolver";
import "../../assets/styles/HR/HrNotificationsPg.css";

function HrNotificationsPg({ onNavigate }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.getNotifications();
      setNotifications(Array.isArray(data) ? data : []);
      setErrorMsg("");
    } catch (e) {
      setErrorMsg(e.message || "Failed to load notifications");
      setNotifications([]);
    } finally { setLoading(false); }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 12000);
    return () => clearInterval(id);
  }, []);

  const unreadCount = notifications.filter(n => n.unread || !n.is_read).length;

  const markAllRead = async () => {
    await api.markAllNotificationsRead();
    setNotifications(prev => prev.map(n => ({ ...n, is_read: true, unread: false })));
  };

  const handleOpen = async (n) => {
    setSelected(n);
    if (n.id && !n.is_read) {
      await api.markNotificationRead(n.id).catch(() => {});
      setNotifications(prev => prev.map(x => x.id === n.id ? { ...x, is_read: true, unread: false } : x));
    }
  };

  const handleNavigate = (n) => {
    if (!onNavigate || !n) return;
    const tab = resolveNotifRoute(n, 'hr');
    onNavigate(tab);
  };

  const fmtTime = (t) => {
    if (!t) return '';
    try {
      const d = new Date(t); const diff = Math.floor((Date.now() - d) / 60000);
      if (diff < 1) return 'Just now';
      if (diff < 60) return `${diff}m ago`;
      if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch { return ''; }
  };

  const typeColor = {
    chat:'#0ea5e9', leave:'#f59e0b', helpdesk:'#ef4444', tickets:'#ef4444',
    payroll:'#16a34a', reports:'#16a34a', announcement:'#8b5cf6', announcements:'#8b5cf6',
    event:'#3b82f6', calendar:'#3b82f6', asset:'#d97706', lost_asset:'#dc2626',
    offboarding:'#dc2626', onboarding:'#6366f1', general:'#94a3b8',
    advances:'#059669', permission:'#f59e0b', permissions:'#f59e0b',
  };
  const getColor = (n) => typeColor[(n.type||'').toLowerCase()] || typeColor[(n.route||'').toLowerCase()] || '#6366f1';

  return (
    <div>
      <div className="sec hrnotificationspg-inline-1">Notifications</div>
      {errorMsg && <div className="toast hrnotificationspg-inline-2">{errorMsg}</div>}

      <div className="cd hrnotificationspg-inline-3">
        <div className="cd-h">
          <div className="cd-t">All Notifications</div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <div className="cd-s">{unreadCount} unread</div>
            <button className="btn-o btn-s" onClick={markAllRead}>Mark all as read</button>
          </div>
        </div>
        <div className="cd-b hrnotificationspg-inline-4">
          {loading ? (
            <div className="hrnotificationspg-inline-5">Loading...</div>
          ) : notifications.length === 0 ? (
            <div className="hrnotificationspg-inline-6">No notifications</div>
          ) : notifications.map((n, idx) => {
            const isUnread = n.unread || !n.is_read;
            const color = getColor(n);
            return (
              <div key={n.id || idx}
                onClick={() => handleOpen(n)}
                className="hrnotificationspg-dyn-1"
                style={{
                  '--hrnotificationspg-1-background':
                    selected?.id === n.id ? '#eef2ff' : isUnread ? '#fafbff' : '#fff',
                  cursor: 'pointer', borderRadius: 8,
                }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <div style={{
                    width: 8, height: 8, borderRadius: '50%', marginTop: 5, flexShrink: 0,
                    background: isUnread ? color : '#e2e8f0',
                    boxShadow: isUnread ? `0 0 0 3px ${color}22` : 'none',
                  }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="hrnotificationspg-inline-7"
                      style={{ fontWeight: isUnread ? 700 : 500, color: isUnread ? '#0f172a' : '#64748b' }}>
                      {n.title || 'Notification'}
                    </div>
                    <div className="hrnotificationspg-inline-8"
                      style={{ color: '#94a3b8', fontSize: 12 }}>
                      {n.body || n.text || ''}
                    </div>
                    <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>{fmtTime(n.created_at)}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Detail + navigate */}
      {selected && (
        <div className="cd" style={{ marginTop: 12 }}>
          <div className="cd-h"><div className="cd-t">Notification Detail</div></div>
          <div className="cd-b">
            <div className="hrnotificationspg-inline-9">{selected.title || 'Notification'}</div>
            <div className="hrnotificationspg-inline-10">{selected.body || selected.text || selected.message || '—'}</div>
            {onNavigate && (
              <button className="btn hrnotificationspg-inline-11" onClick={() => handleNavigate(selected)}>
                Open →
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default HrNotificationsPg;
